var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoExtraFloorSpaceNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-wide-5696124",
    d: "M109.131,105.88a3.264,3.264,0,0,0-3.251,3.258v17.483a3.265,3.265,0,0,0,3.251,3.259h17.489a3.272,3.272,0,0,0,3.259-3.259V109.138a3.271,3.271,0,0,0-3.259-3.258Zm0,1.714h17.489a1.522,1.522,0,0,1,1.544,1.544v17.483a1.522,1.522,0,0,1-1.544,1.544H109.131a1.522,1.522,0,0,1-1.544-1.544V109.138A1.522,1.522,0,0,1,109.131,107.594Zm6.328,1.739-5.22.057h0a.857.857,0,0,0-.849.849l-.062,5.22h0a.857.857,0,1,0,1.714.018l.042-3.179,6.184,6.186,6.189,6.188-3.184.038h0a.857.857,0,1,0,.02,1.714l5.22-.064h0a.857.857,0,0,0,.847-.847l.064-5.22h0a.857.857,0,1,0-1.714-.02l-.039,3.189-12.378-12.378,3.184-.042a.855.855,0,1,0-.018-1.709Z",
    transform: "translate(-105.88 -105.88)",
    fill: "#1d1d1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExtraFloorSpaceNew);
export default __webpack_public_path__ + "static/media/icoExtraFloorSpaceNew.ee4e645aaa2f0218378372330ad5e014.svg";
export { ForwardRef as ReactComponent };